module.exports = __webpack_public_path__ + "img/iso-45001.db82ce5.webp";